export default {
  name: 'project_name',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_mandatory: ['required', 'minLength:3', 'maxLength:50'],
  default_value: 'default_values.project.name'
}